import React from 'react';

function PaddleSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#00253E"
        d="M21.099 9.07c0-5.002-4.074-9.07-9.08-9.07-5.007 0-9.082 4.068-9.082 9.07 0 3.55 2.057 6.622 5.039 8.11.034.02.06.05.098.064.216.085.72.284.713 1.443l.002 3.177c-.05.635.277 1.217.895 1.594.59.361 1.464.542 2.338.542.869 0 1.737-.179 2.324-.536.62-.377.947-.96.902-1.53V18.68c-.008-1.153.496-1.352.712-1.437.037-.015.063-.043.098-.063 2.982-1.49 5.04-4.561 5.04-8.111zm-7.65 12.834c-.158.12-.663.3-1.425.3-.765 0-1.275-.18-1.437-.302v-3.21a5.065 5.065 0 00-.041-.684c.48.08.97.131 1.471.131a9.16 9.16 0 001.471-.13 4.974 4.974 0 00-.04.678v3.217zm-1.432-5.563c-4.015 0-7.28-3.262-7.28-7.271 0-4.01 3.266-7.272 7.28-7.272s7.28 3.262 7.28 7.272c0 4.009-3.265 7.271-7.28 7.271z"
      ></path>
      <rect
        width="7.2"
        height="1.8"
        x="8.4"
        y="8.4"
        fill="#00253E"
        rx="0.9"
      ></rect>
    </svg>
  );
}

export default PaddleSvg;
